import styled from 'styled-components';
import { Card } from '@minerva-analytics/pantheon';

const StyledCard = styled(Card)`
  box-sizing: border-box;
  padding: 2.5rem;
`;

export {
  StyledCard,
};
